import { render, staticRenderFns } from "./TaskEmployment.vue?vue&type=template&id=dec5a8ea&scoped=true"
import script from "./TaskEmployment.vue?vue&type=script&lang=js"
export * from "./TaskEmployment.vue?vue&type=script&lang=js"
import style0 from "./TaskEmployment.vue?vue&type=style&index=0&id=dec5a8ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec5a8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec5a8ea')) {
      api.createRecord('dec5a8ea', component.options)
    } else {
      api.reload('dec5a8ea', component.options)
    }
    module.hot.accept("./TaskEmployment.vue?vue&type=template&id=dec5a8ea&scoped=true", function () {
      api.rerender('dec5a8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskElement/TaskEmployment.vue"
export default component.exports